import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router';
import API from '~/API';
import GriddleCasero from '~/components/GriddleCasero'
import FormularioSuscripcion from '~/components/FormularioSuscripcion';
import moment from 'moment';

const Suscripciones = (props) => {
    const [suscripciones, setSuscripciones] = useState([])
    const [montoMaximo, setMontoMaximo] = useState(null);
    const recaudadores = Object.keys(props.Servicio.Empresa?.otros?.Suscripciones || {});

    const columns = [
        { key: "IdServicioPat", name: "Numero" },
        { key: "Origen", name: "Recaudador" },
        { key: "Activo", name: "Estado", formatter: ({ value, griddleKey, rowData }) => value ? "Activo" : "Inactivo" },
        { key: "FechaInicio", name: "Fecha Creacion", formatter: ({ value }) => moment(value).format("DD/MM/YYYY") },
        { key: "FechaTermino", name: "Fecha Cierre", formatter: ({ value }) => value ? moment(value).format("DD/MM/YYYY") : null }
    ];

    useEffect(() => {
        if (!props.Servicio.idServicio) {
            props.history.replace("/administra")
        } else {
            API.Call(`Recaudacion/${props.Servicio.empresa}/Suscripcion/${props.Servicio.idServicio}/Listado`).then(ev => {
                setSuscripciones(ev)
            });

            API.Call(`Recaudacion/${props.Servicio.empresa}/Suscripcion/MontoMaximo/${props.Servicio.idServicio}`).then(montoInfo => {
                setMontoMaximo(montoInfo.montoMaximo);
            }).catch(montoError => {
                console.error("Error fetching max amount:", montoError);
            });
        }

    }, [])



    return (
        <>
                        {suscripciones.some(o => o.Activo) || !montoMaximo ? null : (
                            <div className="text-right pb-2">
                                <FormularioSuscripcion 
                                    isAnonimo={false}
                                    montoMaximo={montoMaximo}
                                    recaudadores={recaudadores}
                                    servicio={props.Servicio}
                                    empresa={props.Servicio.empresa}
                                    empresaNombre={props.Servicio.Empresa.nombre}
                                    usuario={props.Usuario}
                                />
                            </div>
                        )}

            <Row>
                <Col sm={12} className="bordeIzquierdo">
                    {/* Vista para escritorio y tablet */}
                    <div className="d-none d-md-block">
                        <GriddleCasero
                            data={suscripciones}
                            columns={columns}
                        />
                    </div>

                    {/* Vista para móviles */}
                    <div className="d-md-none">
                        {suscripciones.length > 0 ? (
                            suscripciones.map((item, index) => (
                                <Card key={index} className="mb-3">
                                    <CardBody>
                                        <p><i className="fa fa-hashtag mr-2" /><strong>Número:</strong> {item.IdServicioPat}</p>
                                        <p><i className="fa fa-university mr-2" /><strong>Recaudador:</strong> {item.Origen}</p>
                                        <p><i className={`fa ${item.Activo ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'} mr-2`} /><strong>Estado:</strong> {item.Activo ? "Activo" : "Inactivo"}</p>
                                        <p><i className="fa fa-calendar-plus-o mr-2" /><strong>Fecha Creación:</strong> {moment(item.FechaInicio).format("DD/MM/YYYY")}</p>
                                        <p><i className="fa fa-calendar-times-o mr-2" /><strong>Fecha Cierre:</strong> {item.FechaTermino ? moment(item.FechaTermino).format("DD/MM/YYYY") : 'N/A'}</p>
                                    </CardBody>
                                </Card>
                            ))
                        ) : (
                            <p className="text-center text-muted">No se encontraron suscripciones.</p>
                        )}
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default withRouter(Suscripciones);